import React, { useRef } from "react";
import ReactQuill, { Quill } from "react-quill";
import { Controller } from "react-hook-form";
import "react-quill/dist/quill.snow.css";
import "./editor.css";
import "highlight.js/styles/github.css"; // Import a Highlight.js theme
import hljs from "highlight.js"; // Import Highlight.js

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ size: [] }],
    [{ font: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ align: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image", "video"],
    [{ color: [] }],
    ["clean"],
    ["code-block"],
  ],
  syntax: {
    highlight: (text) => hljs.highlightAuto(text).value,
  },
};
const Editor = ({ name, control, defaultValue = "", id, ...props }) => {
  const quillRef = useRef(null);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <>
          {/* Hidden textarea so <label htmlFor={id}> points to a real form control */}
          {id && (
            <textarea
              id={id}
              readOnly
              value={field.value || ""}
              onFocus={() => {
                // forward focus to quill editor when label is clicked
                try {
                  if (quillRef.current && quillRef.current.focus) {
                    quillRef.current.focus();
                  }
                } catch (e) {
                  // ignore
                }
              }}
              style={{
                position: "absolute",
                left: -9999,
                width: 1,
                height: 1,
                overflow: "hidden",
              }}
              aria-hidden={false}
            />
          )}
          <ReactQuill
            ref={quillRef}
            theme="snow"
            modules={modules}
            value={field.value || ""}
            onChange={field.onChange}
            {...props}
          />
        </>
      )}
    />
  );
};

export default Editor;
